module.exports = __webpack_public_path__ + "img/42a97751-fa26-4f0b-b549-3d0656ed4059.759d309e.png";